import { render, staticRenderFns } from "./index1-single.vue?vue&type=template&id=29840c0e&scoped=true&"
import script from "./index1-single.vue?vue&type=script&lang=js&"
export * from "./index1-single.vue?vue&type=script&lang=js&"
import style0 from "./index1-single.vue?vue&type=style&index=0&id=29840c0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29840c0e",
  null
  
)

export default component.exports